/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StickerSmallIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABTElEQVR4nO1VO04DQQzdigaQkKClzi1IlW7GtpAm9kogBGcAIRJR0IVDQAVNhJScBG5BBUhQUhDk7Cp89uPZhTKWXMzafs/22LNJspSmgsjbQHznSd6AZBajmS9PAELHBPcoz7HAUFB+UYxKAs28PbhkijKuJGjSFqiu4rWmgkVPz3q9vVWPPIjof8HXJAghrM3PAOsWQZmvXQHyQAOBeGhWUOJrEvxVk3gCHjqXbnnih2Lv+X5uQz5vTeCQj/V7RiLXOue6Jx75imh/M4vhk9YEHvndYUpV/p54V31+xTw1vYMPj3ID0N9BPNhQdZR2Pcmt2gBlqmcd1Upgg2BWM0GnJmhrApSpxoQQVoD40iM/5rajf3kqHKXdPKnRV0VyYVTAk1iCkG/wt8xHdosgdHQUmywTxIL/+OGgjPVVrLncxSgC9A+jwZeSlMgn03kH59gdhCoAAAAASUVORK5CYII=)
 */
export const StickerSmallIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M7 3h10a4 4 0 0 1 4 4v6.5a.5.5 0 0 1-.5.5H19a5 5 0 0 0-5 5v1.5a.5.5 0 0 1-.5.5H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm-.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM19 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-9.91 2.94a1 1 0 0 0-1.66 1.12 5.5 5.5 0 0 0 9.14 0 1 1 0 0 0-1.66-1.12 3.5 3.5 0 0 1-5.82 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 16h1.73a3 3 0 0 1-.6.88l-3.25 3.24a3 3 0 0 1-.88.61V19a3 3 0 0 1 3-3Z"
        className={colorClass}
      />
    </svg>
  );
};
